export default ['type', 'source', 'source-layer', 'minzoom', 'maxzoom', 'filter', 'layout'];
//# sourceMappingURL=ref_properties.js.map